// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__c3Ycc","label":"Section_label__2kbkP","contentWrap":"Section_contentWrap__2Ft3t","footer":"Section_footer__2ZnLO","footerInner":"Section_footerInner__2eVk1"};